import { render, staticRenderFns } from "./GHGIInformationFR.vue?vue&type=template&id=2f561c6a"
import script from "./GHGIInformationFR.vue?vue&type=script&lang=js"
export * from "./GHGIInformationFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports